/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-20 22:25:34
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-01-04 23:40:55
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/hooks/useAnchorTabs.ts
 * @Description: 导航nav的数据hooks
 */
import { Data as RegistrationData } from '@quickService/ActivitiesPublicRegistrationPage';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useEventID } from '@hooks/useEventId';
import dataReport from '@utils/data-report';
import update from 'immutability-helper';
import { isMeetingApp } from '@utils/ua/is-mobile';
const scrollToItem = (tagName: string) => {
  const el = document.querySelector<HTMLDivElement>(tagName);
  const container = isMeetingApp()
    ? document.documentElement
    : document.querySelector<HTMLDivElement>('.ma-layout__content');
  if (!el || !container) return;
  const getOffsetToRoot = (element: HTMLDivElement) => {
    let top = element.offsetTop;
    while (element.offsetParent && element.offsetParent !== container) {
      top += (element.offsetParent as HTMLDivElement).offsetTop;
      // eslint-disable-next-line no-param-reassign
      element = element.offsetParent as HTMLDivElement;
    }
    return top;
  };
  // 防遮挡高度
  // @ts-ignore
  const offset: number =
    (document.querySelector<HTMLDivElement>('.ma-anchor-panel-nav')?.offsetHeight || 0) +
    (document.querySelector<HTMLDivElement>('.registration-header')?.offsetHeight || 0);
  container.scrollTo({ top: getOffsetToRoot(el) - offset, behavior: 'smooth' });
};

let clickSet = false;
const useAnchorTabs = ({ activity_introduction, guest }: RegistrationData, curr: number) => {
  const [anchorTabs, id] = useMemo(() => {
    const anchors = [];
    let aId = '';
    if (activity_introduction.content) {
      // 有活动介绍的话，就显示
      anchors.push({ id: 'detail-description', name: '活动介绍', selected: false });
      aId = 'detail-description';
    } else {
      aId = 'active-schedule';
    }
    anchors.push({ id: 'active-schedule', name: '活动日程' });

    if (guest?.length > 0) {
      anchors.push({ id: 'detail-guests', name: '活动嘉宾' });
    }

    return [anchors, aId];
  }, []);
  const [activeId, setActiveId] = useState(id);
  const { eventId } = useEventID();
  const [showAnchorTabs, setShowAnchorTabs] = useState(anchorTabs);

  // 监听导航条快出可视区域时候，将颜色进行变化
  useEffect(() => {
    const el = document.querySelector('.registration-buy-anchor-nav');
    let observer: any;
    if (el && window.IntersectionObserver) {
      observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle('is-pinned', e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );
      // 监听
      observer.observe(el);
    }
    return () => {
      observer?.disconnect?.();
    };
  }, []);

  const changeNavTab = useCallback((id) => {
    scrollToItem(`.${id}-1`);
    setActiveId(id);
    clickSet = true;
    setTimeout(() => {
      clickSet = false;
    }, 1000);
    // debounceSetActivity(id);
    dataReport('e#event_registrationpage#navigation_tab#click', {
      tab_id: ['detail-description', ' active-schedule', 'detail-guests'].indexOf(id),
      activity_id: eventId,
    });
  }, []);

  useEffect(() => {
    let nAnchors: any = anchorTabs;
    let i = 0;
    const len = nAnchors.length;
    for (i; i < len; i++) {
      if (nAnchors[i].id === activeId) {
        nAnchors = update(nAnchors, {
          [i]: {
            selected: {
              $set: true,
            },
          },
        });
      }
    }
    setShowAnchorTabs(nAnchors);
  }, [activeId]);

  // 使用滚动的来做处理吧
  useEffect(() => {
    const element = isMeetingApp()
      ? document.documentElement
      : document.querySelector('.ma-layout__content');
    if (!element) return;
    const regetHeight = () => {
      const tabItems = anchorTabs.map((item) => {
        const id = `${item.id}-1`;
        const tabItem = document.getElementById(id)?.getBoundingClientRect?.();
        return {
          id: item.id,
          offsetTop: (tabItem?.top || 0) + (element?.scrollTop || 0),
          height: tabItem?.height || 0,
        };
      });

      return tabItems;
    };
    const vH = document.body.offsetHeight;
    const scrollFn = (e: any) => {
      window.requestAnimationFrame?.(() => {
        if (clickSet) {
          return;
        }
        const scrollTop = e.target.scrollTop || element.scrollTop;
        const tabItems = regetHeight();
        const viewTab = {
          id: tabItems[0].id,
          maxViewHeight: 0,
        };
        tabItems.forEach((item) => {
          if (item) {
            let showHeight = scrollTop - item.offsetTop + 57;
            if (showHeight > 0 && showHeight < item.height) {
              // 显示了一部分的情况，就是顶部已经到可视区域外了
              showHeight = item.height - showHeight;
            } else if (showHeight < 0 && Math.abs(showHeight) < vH - 57) {
              // 顶部未到可视区域外，但是已经进入可视区域 - 57 - 60,两个悬浮的位置
              showHeight = Math.min(vH + showHeight - 57 - 60, item.height);
            } else {
              showHeight = 0;
            }
            const showPercent = showHeight / item.height;
            if (showPercent >= viewTab.maxViewHeight) {
              viewTab.id = item.id;
              viewTab.maxViewHeight = showPercent;
            }
          }
        });
        setActiveId(viewTab.id);
      });
    };
    (isMeetingApp() ? window : element).addEventListener('scroll', scrollFn);

    return () => {
      (isMeetingApp() ? window : element).removeEventListener('scroll', scrollFn);
    };
  }, [curr]);

  // useEffect(() => {
  //   const observer = new IntersectionObserver(([e]) => {
  //     let i = 0;
  //     const len = anchorTabs.length;
  //     for (i; i < len; i++) {
  //       const idTag = anchorTabs[i].id;
  //       if (e.target.id === `${idTag}-1`) {
  //         break;
  //       }
  //     }
  //     if (e.intersectionRatio > 0.6) {
  //       // 可见的话，就是该id了
  //       // setActiveId(anchorTabs[i].id);
  //       debounceSetActivity(anchorTabs[i].id);
  //     }
  //   }, {
  //     threshold: [0, 0.6, 1],
  //     root: document.querySelector('.ma-layout__content-inner'),
  //   });

  //   anchorTabs.forEach((item) => {
  //     const tabItem = document.querySelector(`#${item.id}-1`);
  //     if (tabItem) {
  //       observer.observe(tabItem);
  //     }
  //   });

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  return {
    anchorTabs: showAnchorTabs,
    changeNavTab,
  };
};

export default useAnchorTabs;
